// Every string on the supplement interaction checker page (STACK-587), as
// Tanu's v5.1 writes it (tickets/STACK-585/artifacts/interaction-checker-mock.html)
// with the gaps tickets/STACK-585/spec.md fills. Aravind approves the copy
// (design doc §3.3); there is no separate wording review.

import seo from './checkerSeo.json';

export const PAGE_PATH = seo.path;
export const SEO_TITLE = seo.title;
export const SEO_DESCRIPTION = seo.description;

export const TITLE = 'Supplement interaction checker';
export const INTRO = 'Up to 3 each.';

export const MEDICATIONS_HEADING = 'Your medications';
export const MEDICATIONS_INSTRUCTION = 'Type a brand or generic name.';
export const MEDICATIONS_PLACEHOLDER = 'e.g. Warfarin';

export const SUPPLEMENTS_HEADING = 'Your supplements';
export const SUPPLEMENTS_INSTRUCTION = 'Type a supplement name.';
export const SUPPLEMENTS_PLACEHOLDER = 'e.g. Magnesium';

export const ADD_ANOTHER = 'Add another';
export const AT_CAP = "That's 3, the free limit. Remove one to add another.";
// Signed in, the cap is the same 3 but not a free tier: no "free" (Aravind,
// 2026-10-16, STACK-596). Proposed copy, for Aravind's review.
export const AT_CAP_SIGNED_IN = "That's 3, the limit. Remove one to add another.";

export const SEARCHING = 'Searching…';
export const ADDING = 'Adding…';
export const noMatchTitle = (query) => `No match for "${query}"`;
export const MEDICATION_NO_MATCH = 'Check the spelling, or try the generic name.';
// v5.1 draws the no-match state once, for medications. A supplement that is
// not on our list can't be checked yet (Aravind, 2026-10-13; design doc §3
// step 3), so its line says so — proposed copy, for Aravind's review.
export const SUPPLEMENT_NO_MATCH = "Check the spelling. If it's right, we can't check that supplement yet.";
export const MEDICATION_SEARCH_FAILED = "We can't search medications right now. Try again in a minute.";
// Not drawn in v5.1: our supplement list failed to load. Proposed copy.
export const SUPPLEMENT_LIST_FAILED = "We can't search supplements right now. Try again in a minute.";
export const COULDNT_ADD = (name) => `We couldn't add ${name}. Try again, or try its generic name.`;
export const TRY_AGAIN = 'Try again';
export const GENERIC = 'Generic';
export const brandOf = (generic) => `Brand of ${generic.toLowerCase()}`;

export const CHECK = 'Check';
// What a disabled Check is waiting for. v5.1 draws the first two; the third
// is their mirror.
export const NEEDS_BOTH = 'Add a medication and a supplement to check.';
export const NEEDS_SUPPLEMENT = 'Add a supplement to check.';
export const NEEDS_MEDICATION = 'Add a medication to check.';

export const CHECKING_TITLE = 'Checking your supplements';
export const CHECKING_BODY = 'This takes a few seconds.';

export const COULDNT_CHECK_TITLE = "We couldn't check right now";
export const COULDNT_CHECK_BODY = 'Nothing was checked. Try again in a few minutes.';

const joinWith = (names, word) => {
  if (names.length <= 1) return names.join('');
  return `${names.slice(0, -1).join(', ')} ${word} ${names[names.length - 1]}`;
};

/** "With Warfarin and Sertraline" — the medications a supplement was flagged with. */
export const flaggedWith = (names) => `With ${joinWith(names, 'and')}`;
/** "Not flagged with Warfarin or Sertraline" — only ever from a completed check. */
export const notFlaggedWith = (names) => `Not flagged with ${joinWith(names, 'or')}`;
/** "Hyzaar: checked as losartan" — the one ingredient a medication was checked as. */
export const checkedAs = (displayName, ingredientName) => `${displayName}: checked as ${ingredientName.toLowerCase()}`;

// The trial card under every result (STACK-588; v5.1 states 7, 9 and 11).
export const TRIAL_HEADING = 'Keep your stack checked';
export const TRIAL_PERKS = ['Check more than 3 supplements', 'Save your medications', 'New supplements checked automatically'];
export const TRIAL_BUTTON = 'Start free trial';
export const TRIAL_NOTE = '14 days free. Cancel anytime.';
